<template>
  <div class="flex items-center justify-between gap-2 flex-wrap">
      <h1 class="text-xl font-semibold">
        แดชบอร์ด <span class="text-sm text-slate-500">({{ n(stats.total_all) }})</span>
      </h1>
      <div class="flex items-center gap-2">
        <span class="text-sm text-slate-500 hidden md:block">สวัสดี, {{ auth.user?.username }}</span>
        <button class="btn-outline" @click="logout">ออกจากระบบ</button>
      </div>
    </div>
    <div class="grid gap-4 md:grid-cols-3 mt-6 mb-2">
      <div class="bg-white border border-slate-200 rounded-2xl p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="font-semibold">จำนวนทั้งหมด</h3>
          <i class="mdi mdi-account-group-outline text-2xl text-slate-700"></i>
        </div>
        <div class="text-4xl font-semibold text-blue-600">{{ n(stats.total) }}</div>
        <!-- <div class="text-slate-500 mt-1 text-sm">จำนวนทั้งหมด</div> -->
      </div>
      
      <div class="bg-white border border-slate-200 rounded-2xl p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="font-semibold">จำนวนอายุผ่านเกณฑ์</h3>
          <i class="mdi mdi-account-group-outline text-2xl text-slate-700"></i>
        </div>
        <div class="text-4xl font-semibold text-green-600">{{ n(stats.passed) }}</div>
      </div>
      <div class="bg-white border border-slate-200 rounded-2xl p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="font-semibold">จำนวนอายุไม่ผ่านเกณฑ์</h3>
          <i class="mdi mdi-account-group-outline text-2xl text-slate-700"></i>
        </div>
        <div class="text-4xl font-semibold text-red-600">{{ n(stats.failed) }}</div>
      </div>
    </div>
  <div ref="mountPoint" class="min-h-[50vh]"></div>
</template>

<script setup>
defineOptions({ name: 'Dashboard' })
import { ref, onMounted, onBeforeUnmount } from 'vue'
import api from '../../api/http.js'

import { useAuth } from '../../stores/auth'
import { useRouter } from 'vue-router'

const auth = useAuth()
const router = useRouter()

const mountPoint = ref(null)
let subApp = null
let vuetifyInstance = null

const stats = ref({ forms: 0, passed: 0, failed: 0 })
const nf = new Intl.NumberFormat('th-TH')
const n  = v => nf.format(v ?? 0)

async function logout() {
  await auth.logout()
  router.push('/admin')
}

function enableVuetifyStyles() {
  document.querySelectorAll('style[data-vuetify-micro],link[rel="stylesheet"][data-vuetify-micro]')
    .forEach(n => {
      if (n.tagName === 'LINK') n.disabled = false
      else n.setAttribute('media', '')
    })
}

function disableVuetifyStyles() {
  document.querySelectorAll('style[data-vuetify-micro],link[rel="stylesheet"][data-vuetify-micro]')
    .forEach(n => {
      if (n.tagName === 'LINK') n.disabled = true
      else n.setAttribute('media', 'not all')
    })
}

onMounted(async () => {

  const existed = document.querySelectorAll('style[data-vuetify-micro],link[rel="stylesheet"][data-vuetify-micro]').length > 0
  if (!existed) {
    const before = new Set([...document.head.querySelectorAll('style,link[rel="stylesheet"]')])

    const [{ createApp }, { createVuetify }, components, directives, SubAppMod] = await Promise.all([
      import('vue'),
      import('vuetify'),
      import('vuetify/components'),
      import('vuetify/directives'),
      import('./member.vue'),
    ])


    await Promise.all([
      import('vuetify/styles'),
      import('@mdi/font/css/materialdesignicons.css'),
    ])

   
    const after = [...document.head.querySelectorAll('style,link[rel="stylesheet"]')]
    after.forEach(n => {
      if (!before.has(n)) n.setAttribute('data-vuetify-micro', '1')
    })


    vuetifyInstance = createVuetify({ components, directives })
    subApp = createApp(SubAppMod.default)
    subApp.use(vuetifyInstance)
    subApp.mount(mountPoint.value)
  } else {
    
    enableVuetifyStyles()

    const [{ createApp }, { createVuetify }, components, directives, SubAppMod] = await Promise.all([
      import('vue'),
      import('vuetify'),
      import('vuetify/components'),
      import('vuetify/directives'),
      import('./member.vue'),
    ])
    vuetifyInstance = createVuetify({ components, directives })
    subApp = createApp(SubAppMod.default)
    subApp.use(vuetifyInstance)
    subApp.mount(mountPoint.value)
  }
  const { data } = await api.get('/admin/forms/count')
  stats.value.total_all  = data.total_all
  stats.value.total  = data.total
  stats.value.passed = data.passed ?? 0
  stats.value.failed = data.failed ?? 0
    
})

onBeforeUnmount(() => {
  document.body.classList.remove('page-fullwidth-line')
  if (subApp) {
    subApp.unmount()
    subApp = null
  }
  vuetifyInstance = null
  disableVuetifyStyles()
})
</script>
<style>
main.container.py-8 {
  max-width: none !important;
  width: 90% !important;
  padding-left: 1rem;  
  padding-right: 1rem;
}
</style>



